import styled from 'styled-components';
import { responsiveBreakPoints } from '../../ApplicationKYC/LegalEntityQuestionnaire/styled-theme-styles/styled-components.d';

export const OndatoSuccessWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  gap: 1rem;

  @media (${responsiveBreakPoints.maxPhone}) {
    padding: 1rem;
  }
`;

export const OndatoSuccessHeader = styled.h1`
  font-size: 1.5rem;
  font-weight: 500;
`;

export const OndatoSuccessSubHeader = styled.h2`
  font-size: 1.375rem;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.base.black.shades[60]};
  font-size: 0.875rem;
  max-width: 33.75rem;
`;
